module.exports = __webpack_public_path__ + "img/xpress.57daa4a2.svg";